import React from 'react';
import { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';
import { sizes, theme } from 'theme';

type CheckboxInputProps = {
    id: string;
    // name: string;
    // value: string;
    unfocusable?: boolean;
    aria: string;
} & ComponentPropsWithoutRef<'input'>;

const CheckboxInput = React.forwardRef<HTMLInputElement, CheckboxInputProps>(
    // ({ id, name, value, unfocusable, aria, ...props }, ref) => {
    ({ id, unfocusable, aria, ...props }, ref) => {
        return (
            <Checkbox
                ref={ref}
                aria-label={aria}
                type="checkbox"
                id={id}
                // name={name}
                // value={value}
                tabIndex={unfocusable ? -1 : 0}
                {...props}
            />
        );
    },
);

export default CheckboxInput;

export const TextBlock = styled.label`
    display: block;
    width: 100%;
    border: solid 1px ${theme.cardBorder};
    border-radius: ${sizes.borderRadiusLg};
    padding: ${sizes.rem.rg} ${sizes.rem.sm} ${sizes.rem.md} 3.5rem;
`;

const Checkbox = styled.input`
    cursor: pointer;
    min-width: 1.75rem;
    min-height: 1.75rem;
    &:focus ~ ${TextBlock} {
        background-color: ${theme.inputRadioButton.focusBackgroundColour};
        border: 2px solid ${theme.inputRadioButton.checkedBorderColour};
    }
    &:checked {
        accent-color: ${theme.inputRadioButton.activeRadioColour};
    }
    &:checked ~ ${TextBlock} {
        border: 2px solid ${theme.inputRadioButton.checkedBorderColour};
    }
    &:hover ~ ${TextBlock} {
        background-color: ${theme.inputRadioButton.hoverBackgroundColour};
    }
`;
